import axios from 'axios';
import api from '../../../utils/api';
import { EMPTY_SEARCH_RESULT, MUTATE_SEARCH_RESULT } from './types';

export default {
  async getCoreSearch({ commit }, keyword) {
    if (keyword) {
      const { data } = await axios(api.core.globalSearch(keyword));
      commit(MUTATE_SEARCH_RESULT, { data });
    } else commit(EMPTY_SEARCH_RESULT);
  },
};
